var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "postRequest", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "mr-l-10" }, [_vm._v("タイトル")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.postRequest.title,
                    expression: "postRequest.title"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.postRequest.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.postRequest, "title", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mr-l-10 mr-t-20" }, [_vm._v("本文")]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.postRequest.content,
                    expression: "postRequest.content"
                  }
                ],
                staticClass: "w-rate-100 h-150 form-control",
                domProps: { value: _vm.postRequest.content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.postRequest, "content", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer flexbox justify-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-warning w-150 mr-r-10",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    disabled: _vm.isDisableButton
                  },
                  on: {
                    click: function($event) {
                      _vm.postNewRequest()
                    }
                  }
                },
                [_vm._v("\n          投稿\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [
                  _c("button", { staticClass: "btn ver-middle w-120" }, [
                    _vm._v("閉じる")
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cb6141e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb6141e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/request/PostRequest.vue
// module id = null
// module chunks = 